export default __webpack_public_path__ + "static/media/014-jump rope.4fbbd219.svg";